import { render, staticRenderFns } from "./AbsenceObject.vue?vue&type=template&id=74a9b110&lang=pug&"
import script from "./AbsenceObject.vue?vue&type=script&lang=ts&"
export * from "./AbsenceObject.vue?vue&type=script&lang=ts&"
import style0 from "./AbsenceObject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports